import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import Layout from "../../shared/components/Layout";
import SidebarNavigation from '@/components/SidebarNavigation';
import createPromoCare from '../api/createPromoCare';

import { PromoCareOrderParams, PromoCareProduct } from '../types';
import ProductList from '../components/ProductList';
import { convertKeysToSnakeCase } from '@/utils/format';
import { useOrderContext } from '@/providers/OrderProvider';
import InfoDisplay from '@/components/InfoDisplay';

const PromoCareConfirm: React.FC = () => {
  const navigate = useNavigate();
  const [promoProducts, setPromoProducts] = useState<PromoCareProduct[]>([]);
  const [careProducts, setCareProducts] = useState<PromoCareProduct[]>([]);

  const [orderParams, setOrderParams] = useState<PromoCareOrderParams>({
    order: {
      order_type: 'promo_care',
      note: '',
      arrivalDate: '',
      arrivalTimeZone: '',
      facilityId: undefined,
      expectedShipDate: undefined,
      shortestArrivalDate: undefined,
      orderPromoCareItemsAttributes: undefined,
    },
  });
  const { arrivalTimeZoneLabels } = useOrderContext();

  useEffect(() => {
    const storedOrderParams = localStorage.getItem("orderParams");
    if (storedOrderParams) {
      setOrderParams(JSON.parse(storedOrderParams));
    }

    const storedPromoProducts = localStorage.getItem("promoProducts");
    if (storedPromoProducts) {
      setPromoProducts(JSON.parse(storedPromoProducts));
    }

    const storedCareProducts = localStorage.getItem("careProducts");
    if (storedCareProducts) {
      setCareProducts(JSON.parse(storedCareProducts));
    }
  }, []);

  const convertedArrivalTimeZoneLabels = convertKeysToSnakeCase(arrivalTimeZoneLabels);

  const handleSubmit = async (e: React.MouseEvent<HTMLFormElement>) => {
    e.preventDefault()
    const params: PromoCareOrderParams = orderParams

    try {
      const res = await createPromoCare(params);
      if(res.status === 201) {
        localStorage.removeItem("orderParams");
        localStorage.removeItem("promoProducts");
        localStorage.removeItem("careProducts");

        navigate("/facility/orders/promo_care/complete");
      } else if(res.status !== 201) {
        navigate("/facility/orders/promo_care");
        window.scrollTo(0, 0)
        console.error(`status: ${res.status}, message: ${res.statusText}`);
      }

    } catch (err: any) {
      navigate("/facility/orders/promo_care");
      window.scrollTo(0, 0);
      console.log('An unexpected error occurred:', err.message);
    }
  }

  const renderPreviousPage = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    navigate("/facility/orders/promo_care", { state: { fromConfirmPage: true } });
    window.scrollTo(0, 0);
  }

  return (
    <React.Fragment>
      <Layout>
        <main id="page-facility_login" className="wrapper">
          <section className="sec-contact">
            <div className="inner">
              <h1 className="c-ttl__01">ケア用品・販促品注文確認</h1>
              <div className="contact-box">
                <div className="contact-box__left">
                  <form onSubmit={handleSubmit}>
                      { careProducts.length > 0 && 
                        <div className="contact-box__form mbpc-59 js-item" id="id-01">
                          <ProductList
                            products={careProducts}
                            orderItems={orderParams.order.orderPromoCareItemsAttributes}
                            title="ケア用品"
                          />
                        </div>
                      }
                      { promoProducts.length > 0 && 
                        <div className="contact-box__form mbpc-63 js-item" id="id-02">
                          <ProductList
                            products={promoProducts}
                            orderItems={orderParams.order.orderPromoCareItemsAttributes}
                            title="販促品"
                          />
                        </div>
                      }
                    <div className="contact-box__form mbpc-29 js-item" id="id-03">
                      <h2 className="c-ttl__02">配送等について</h2>
                      <InfoDisplay label="備考" value={orderParams?.order?.note} />
                      <InfoDisplay label="着日指定" value={orderParams?.order?.arrivalDate ? orderParams?.order?.arrivalDate : "最短お届け日"} />
                      <InfoDisplay label="ご希望時間帯" value={convertedArrivalTimeZoneLabels[orderParams?.order?.arrivalTimeZone]} />
                    </div>
                    <button type="submit" className="c-btn__01">注文確定</button>
                  </form>
                  <div className="c-al--c">
                    <button className="c-btn__02" onClick={renderPreviousPage}>前のページに戻る</button>
                  </div>
                </div>
                { (promoProducts.length === 0 && careProducts.length > 1) && 
                  <SidebarNavigation items={[{ id: "id-01", label: "ケア用品" }, { id: "id-03", label: "配送等について" }]} />
                }
                { (careProducts.length === 0 && promoProducts.length > 1) && 
                  <SidebarNavigation items={[{ id: "id-02", label: "販促品" }, { id: "id-03", label: "配送等について" }]} />
                }
                { (promoProducts.length > 1 && careProducts.length > 1) && 
                  <SidebarNavigation items={[{ id: "id-01", label: "ケア用品" }, { id: "id-02", label: "販促品" }, { id: "id-03", label: "配送等について" }]} />
                }
              </div>
            </div>
          </section>
        </main>
      </Layout>
    </React.Fragment>
  )
}

export default PromoCareConfirm;
